export default "__VITE_ASSET__Bix1LGfx__"